import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './index.module.css';

const InfoBox = ({ title, children, icon = 'info', variant = 'slim', className = '', defaultExpanded = false }) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const variantClass = `info-box__toggle--${variant}`;
  const iconClass = icon ? `info-box__toggle--icon-${icon}` : '';
  const buttonClass = `info-box__toggle ${variantClass} info-box__toggle--button info-box__toggle--icon ${iconClass}${isExpanded ? ' info-box__toggle--open' : ''}`;
  const textClass = `info-box__toggle ${variantClass} info-box__toggle--text info-box__toggle--icon ${iconClass}`;

  return (
    <div className={`info-box${className ? ` ${className}` : ''}`}>
      <h3 className="info-box__title">
        <button
          type="button"
          className={buttonClass}
          aria-expanded={isExpanded}
          onClick={toggleExpanded}
        >
          {title}
        </button>
        <span className={textClass}>
          {title}
        </span>
      </h3>
      <div className={`info-box__content info-box__content--${variant}${isExpanded ? ' info-box__content--expanded' : ''}`}>
        {children}
      </div>
    </div>
  );
};

InfoBox.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  icon: PropTypes.oneOf(['info', 'error', 'success']),
  variant: PropTypes.oneOf(['slim', 'no-responsive']),
  className: PropTypes.string,
  defaultExpanded: PropTypes.bool
};

export default InfoBox;
